import { signal } from "@preact/signals-react"

export const StockChangesPriceEvolutionFilters = signal({})
export const StockChangesStockEvolutionFilters = signal({})
export const stockChangesCurrentPeriod = signal("")
export const stockChangesEndDate = signal("")

export const StockChangesReportFormIsOpen = signal(false)
export const StockChangesSubmittedFilters = signal({})